import { render, staticRenderFns } from "./AddClassroomModal.vue?vue&type=template&id=7020cbc1&scoped=true"
import script from "./AddClassroomModal.vue?vue&type=script&lang=js"
export * from "./AddClassroomModal.vue?vue&type=script&lang=js"
import style0 from "./AddClassroomModal.vue?vue&type=style&index=0&id=7020cbc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7020cbc1",
  null
  
)

export default component.exports